import { render, staticRenderFns } from "./hotspot-question-component.vue?vue&type=template&id=eb9b93d0&scoped=true&"
import script from "./hotspot-question-component.vue?vue&type=script&lang=ts&"
export * from "./hotspot-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./hotspot-question-component.vue?vue&type=style&index=0&id=eb9b93d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9b93d0",
  null
  
)

export default component.exports